import { TableCell, TableRow } from '@material-ui/core'
import { withStyles, Theme, createStyles } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'

import useStyles from './styles/creditorTableSkeleton.styles'

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#a5a5a5',
      color: theme.palette.common.white
    },
    body: {
      fontSize: 14
    }
  })
)(TableCell)

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      gridTemplateColumns: '2fr 2fr 2fr 2fr 2fr 2fr 1fr',
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow)

export const CreditorTableSkeleton = () => {
  const classes = useStyles()

  return (
    <StyledTableRow>
      <StyledTableCell component="th" scope="row">
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell component="th" scope="row">
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="right">
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="right">
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <StyledTableCell align="right">
        <Skeleton animation="wave" className={classes.skeleton} />
      </StyledTableCell>
      <div />
    </StyledTableRow>
  )
}
